import type { FC, HTMLProps } from 'react';
import { forwardRef } from 'react';

import { ClickableContainer, Label, StyledIcon } from './styled';

import type { IconName } from '../Icon';

export interface IIconButtonProps
    extends Omit<HTMLProps<HTMLButtonElement>, 'as' | 'onClick' | 'type'> {
    onClick: () => void;
    iconName: IconName;
    label: string;
    ref?: React.Ref<HTMLButtonElement>;
}

export const IconButton: FC<IIconButtonProps> = forwardRef(
    (
        { onClick, iconName, label, ...buttonProps },
        ref: React.Ref<HTMLButtonElement>
    ) => (
        <ClickableContainer onClick={onClick} {...buttonProps} ref={ref}>
            <StyledIcon iconName={iconName} />
            <Label>{label}</Label>
        </ClickableContainer>
    )
);
